import { render, staticRenderFns } from "./SyaratKetentuan.vue?vue&type=template&id=52b33fc8&scoped=true"
import script from "./SyaratKetentuan.vue?vue&type=script&lang=js"
export * from "./SyaratKetentuan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b33fc8",
  null
  
)

export default component.exports